import { Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { WizardStep as WizardStepType } from "../../common/types/wizard";
import WizardSingleParameterBlock from "./wizard-single-parameter-block";
import GeneralErrorMessage from "../error/general-error";
import { ParameterValue } from "../../common/types/parameters";
import WizardMultiParameterBlock from "./wizard-multi-parameter-block";

const useStyles = makeStyles(() => ({
  container: {
    margin: "0 4em",
  },
}));

export default function WizardStep(params: {
  info: WizardStepType;
  preSelected?: ParameterValue[];
  onSelection?: (parameterValues: ParameterValue[]) => void;
}) {
  const classes = useStyles();

  return params.info ? (
    <div className={classes.container}>
      <Typography
        style={{
          fontWeight: 300,
          textAlign: "center",
          fontSize: "30px",
        }}
      >
        {params.info.displayName}
      </Typography>
      <Typography paragraph>{params.info.description}</Typography>
      {params.info.inputParameters.length === 1 ? (
        <WizardSingleParameterBlock
          id={params.info.id}
          inputParameter={params.info.inputParameters[0]}
          preSelected={params.preSelected?.at(0)?.value}
          onSelection={(val: string) => {
            if (params.onSelection !== undefined) {
              params.onSelection([
                { id: params.info.inputParameters[0].id, value: val },
              ]);
            }
          }}
        />
      ) : params.info.inputParameters.length > 1 ? (
        <WizardMultiParameterBlock
          id={params.info.id}
          parameters={params.info.inputParameters}
          preSelected={params.preSelected}
          onSelection={params.onSelection}
        />
      ) : (
        <GeneralErrorMessage />
      )}
    </div>
  ) : (
    <div></div>
  );
}
